import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import AdminSurveyAnalysisReportDownload from "./AdminSurveyAnalysisReportDownload";
import { get_Date } from "../../Utils/commonFunctions";
import {
  getSurveyAnalysisReportPreView,
  updateSurveStatus,
} from "../../Utils/adminFunctions";
import {
  AdminQuestionOption,
  AnalysisReportAdminGraph,
  AdminTextResponcesPriview,
} from "./AdminCommanComponent";
const AdminSurveyAnalysisReportPreview = () => {
  const navigate = useNavigate();
  const { surveyID } = useParams(); ///survey ID
  const [surveyData, setSurveyData] = useState("");
  const [analysisReport, setAnalysisReport] = useState("");
  useEffect(() => {
    AdminUserSurveyAnalysisReportPreview();
  }, []);
  const AdminUserSurveyAnalysisReportPreview = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    const response = await getSurveyAnalysisReportPreView(bodyFormData);
    if (response.status === "success") {
      let colors = response.data.survey_result[0].COLOR;
      setSurveyData(response.data.survey_result[0]);
      if (Object.keys(response.data.anyreports).length === 0) {
        setAnalysisReport("");
      } else {
        let dataObject = response.data.anyreports;
        let isChart,
          options,
          reportChartsData,
          textResponcesData,
          tempChartData,
          textResponcesInclude;
        let analysisReport = Object.keys(dataObject).map(function (key, index) {
          let questionType = dataObject[key].type;
          if (dataObject[key].reportscharts.length === 0) {
            isChart = 0;
            tempChartData = "";
          } else {
            isChart = 1;
            reportChartsData = dataObject[key].reportscharts;
            tempChartData = Object.keys(reportChartsData).map(function (
              key,
              index2
            ) {
              let item = reportChartsData[key];
              return (
                <div
                  className="col-md-6 mb-4 d-flex align-items-stretch"
                  key={index2}
                >
                  <AnalysisReportAdminGraph reportsCharts={item} key={index2} />
                </div>
              );
            });
          }
          if (dataObject[key].options === "") {
            options = "";
          } else {
            options = dataObject[key].options;
          }
          if (dataObject[key].textresponse.length === 0) {
            textResponcesInclude = "";
          } else {
            let isInclude = dataObject[key].isinclude;
            if (isInclude === 1) {
              textResponcesData = dataObject[key].textresponse;
              textResponcesInclude = (
                <div className="row mb-4">
                  <div className="col-md-12 text-left">
                    <h6 className="p-0">
                      <strong>Text response</strong>
                    </h6>
                    {Object.keys(textResponcesData).map(function (key, index3) {
                      let TextitemData = textResponcesData[key];
                      return (
                        <AdminTextResponcesPriview
                          label={TextitemData.label}
                          key={index3}
                          textResponseItem={TextitemData.textresponseitem}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            } else {
              textResponcesInclude = "";
            }
          }
          return (
            <div className="row" key={index}>
              <div className="col-md-12">
                <div className="sar-question p-1">
                  <div className="sar-question-number">{index + 1}</div>
                  <span className="sar-question-text">
                    {dataObject[key].label}
                    {dataObject[key].type === "survey"
                      ? " > " + dataObject[key].survey_label
                      : ""}
                  </span>
                </div>
                {(questionType === "radio" ||
                  questionType === "selectboxes" ||
                  questionType === "survey") && (
                  <AdminQuestionOption
                    questionType={questionType}
                    isChart={isChart}
                    options={options}
                    colors={colors}
                  />
                )}
              </div>
              {tempChartData}
              {textResponcesInclude != "" && textResponcesInclude}
            </div>
          );
        });

        setAnalysisReport(analysisReport);
      }
    }
  };
  const handleSurveyStatus = async (surveyStatus) => {
    const response = await updateSurveStatus(surveyID, surveyStatus);
    if (response.status == "success") {
      toast.success(response.message, { autoClose: 1500 });
      navigate("/AdminSurveyDetails/" + surveyID);
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 mb-2">
                    <h3 className="card-title  ">
                      <AdminSurveyAnalysisReportDownload></AdminSurveyAnalysisReportDownload>
                    </h3>
                    <h3 className="card-title pull-right ">
                      <Link
                        to={"/AdminSurveyAnalysisReport/" + surveyID}
                        className="btn btn-sm custom-btn-primary"
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </Link>
                    </h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12" id="page">
                            <table
                              className="table analysis-preview-table table-bordered"
                              id="surveyAnalysisReportTable"
                            >
                              <tbody>
                                <tr>
                                  <td colSpan={2}>
                                    <center>
                                      <img
                                        src={
                                          surveyData.manufacturer__company_logo
                                        }
                                        style={{
                                          maxHeight: "35px",
                                          margin: "10px",
                                          width: "auto",
                                        }}
                                      />
                                      <br></br>
                                      {surveyData.manufacturer__company_name}
                                    </center>
                                  </td>
                                  <td rowSpan={4}>
                                    <center>
                                      <img
                                        src={surveyData.device__device_image}
                                        style={{
                                          maxHeight: "150px",
                                          width: "auto",
                                        }}
                                      />
                                    </center>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2}>
                                    <center>
                                      <b>{surveyData.survey_name}</b>
                                    </center>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="width-20">No. of responses</td>
                                  <td className="width-60">
                                    {surveyData.no_of_responses}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="width-20">Launch Date</td>
                                  <td className="width-60">
                                    {get_Date(surveyData.launch_date)}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="width-20">Completion Date</td>
                                  <td className="width-60">
                                    {get_Date(surveyData.completion_date)}
                                  </td>
                                  <td>
                                    <center>
                                      {surveyData.device__device_name}
                                    </center>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {analysisReport}
                        {surveyData.status === "completed" && (
                          <p className="text-center mt-4">
                            <button
                              className="btn btn-sm custom-btn-primary"
                              onClick={() => {
                                handleSurveyStatus("final_save");
                              }}
                            >
                              {" "}
                              Save final survey analysis report
                            </button>{" "}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminSurveyAnalysisReportPreview;
